import * as React from 'react';

import PulseResponse from '../../pulse/PulseResponse';

interface IProps {
    refetch: VoidFunction;
}

function Results({ refetch }: IProps): JSX.Element {
    return <>
        <PulseResponse refetch={refetch} />
    </>;
}

export default Results;
